import React, { useState, useEffect } from 'react';
import { useContent } from '../../contexts/ContentContext';
import ImageUpload from './ImageUpload';
import './ValuesAdmin.css';

const ValuesAdmin = ({ contentPath }) => {
  const { getContent, updateContent } = useContent();
  const [sectionData, setSectionData] = useState(null);

  useEffect(() => {
    const data = getContent(contentPath);
    setSectionData(data);
  }, [contentPath, getContent]);

  const handleSectionUpdate = (field, value) => {
    updateContent(`${contentPath}.${field}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleValueUpdate = (index, field, value) => {
    updateContent(`${contentPath}.values.${index}.${field}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleAddValue = () => {
    const values = sectionData?.values || [];
    const newValue = {
      icon: 'fas fa-award',
      iconImage: '',
      title: '',
      description: ''
    };

    updateContent(`${contentPath}.values`, [...values, newValue]);
    setSectionData(getContent(contentPath));
  };

  const handleDeleteValue = (index) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette valeur ?')) {
      const values = sectionData?.values || [];
      const updatedValues = values.filter((_, i) => i !== index);
      updateContent(`${contentPath}.values`, updatedValues);
      setSectionData(getContent(contentPath));
    }
  };

  if (!sectionData) {
    return (
      <div className="values-admin-loading">
        <i className="fas fa-spinner fa-spin"></i>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="values-admin">
      {/* Section Header Settings */}
      <div className="admin-section-header">
        <div className="section-info">
          <h2>
            <i className="fas fa-heart"></i>
            Valeurs Fondamentales
          </h2>
          <p>Gérez les valeurs qui définissent votre organisation</p>
        </div>
        <button 
          className="btn-add-value"
          onClick={handleAddValue}
        >
          <i className="fas fa-plus"></i>
          Ajouter une valeur
        </button>
      </div>

      {/* Section Title & Subtitle */}
      <div className="section-settings">
        <div className="setting-group">
          <label>Titre de la section</label>
          <input
            type="text"
            value={sectionData.title || ''}
            onChange={(e) => handleSectionUpdate('title', e.target.value)}
            placeholder="Nos Valeurs Fondamentales"
          />
        </div>
        <div className="setting-group">
          <label>Sous-titre</label>
          <textarea
            value={sectionData.subtitle || ''}
            onChange={(e) => handleSectionUpdate('subtitle', e.target.value)}
            placeholder="Description de vos valeurs..."
            rows={2}
          />
        </div>
      </div>

      {/* Values List */}
      <div className="values-list-admin">
        {(sectionData.values || []).map((value, index) => (
          <div key={index} className="value-item-admin">
            <div className="value-header">
              <div className="value-title-area">
                <h3>
                  <i className={value.icon || 'fas fa-award'}></i>
                  Valeur {index + 1}
                </h3>
              </div>
              <div className="value-actions">
                <button
                  className="btn-delete"
                  onClick={() => handleDeleteValue(index)}
                  title="Supprimer cette valeur"
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </div>

            {/* Clean Horizontal Form Fields */}
            <div className="form-grid">
              <div className="form-group">
                <label>Icône FontAwesome (optionnel si vous téléchargez une image)</label>
                <input
                  type="text"
                  value={value.icon || ''}
                  onChange={(e) => handleValueUpdate(index, 'icon', e.target.value)}
                  placeholder="fas fa-lightbulb"
                />
                <small style={{color: '#6b7280', fontSize: '12px'}}>
                  Exemples: fas fa-lightbulb, fas fa-award, fas fa-heart, fas fa-certificate
                </small>
              </div>

              <div className="form-group full-width">
                <label>Image personnalisée (prioritaire sur l'icône FontAwesome)</label>
                <ImageUpload
                  value={value.iconImage}
                  onChange={(url) => handleValueUpdate(index, 'iconImage', url)}
                  label="Télécharger votre icône personnalisée"
                />
                <small style={{color: '#6b7280', fontSize: '12px', display: 'block', marginTop: '8px'}}>
                  Si vous téléchargez une image, elle sera utilisée à la place de l'icône FontAwesome. Recommandé: 200x200px
                </small>
              </div>

              <div className="form-group full-width">
                <label>Titre</label>
                <input
                  type="text"
                  value={value.title || ''}
                  onChange={(e) => handleValueUpdate(index, 'title', e.target.value)}
                  placeholder="Innovation"
                />
              </div>

              <div className="form-group full-width">
                <label>Description</label>
                <textarea
                  value={value.description || ''}
                  onChange={(e) => handleValueUpdate(index, 'description', e.target.value)}
                  placeholder="Description de cette valeur..."
                  rows={3}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {(!sectionData.values || sectionData.values.length === 0) && (
        <div className="empty-state">
          <div className="empty-icon">
            <i className="fas fa-heart"></i>
          </div>
          <h3>Aucune valeur définie</h3>
          <p>Commencez par ajouter votre première valeur fondamentale.</p>
          <button className="btn-add-first" onClick={handleAddValue}>
            <i className="fas fa-plus"></i>
            Ajouter la première valeur
          </button>
        </div>
      )}
    </div>
  );
};

export default ValuesAdmin;



